// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"727":"df49b9ed","750":"e9624c3d"}[chunkId] + ".chunk.js";
};